import { useState } from "react";
import CustomButton from "../button/Button";

const ToggleViews = ({ views }) => {
  const [currentView, setCurrentView] = useState(0);

  return (
    <div>
      <div style={{ marginBottom: "1rem", display: "flex" }}>
        {/* Renderizar botones dinámicamente */}
        {views.map((view, index) => (
          <div style={{ marginRight: "5px" }} key={index}>
            <CustomButton
              background={currentView === index ? "#D9D9D9" : "#FFFFFF"}
              width={view.name === "Subir archivo" ? "129px" : "166px"}
              height={"31px"}
              fontStyle={"normal"}
              fontWeight={700}
              fontSize={"14px"}
              color={"#223D51"}
              text={view.name}
              border={"none"}
              onClick={() => setCurrentView(index)}
              type={"bottom"}
            />
          </div>
        ))}
      </div>

      {/* Mostrar la vista seleccionada */}
      <div>{views[currentView] && views[currentView].content}</div>
    </div>
  );
};

export default ToggleViews;
